const s = ':host{display:block}.sl-topbar{display:flex;align-items:center;height:var(--sl-topbar-height,3.5rem);background:hsl(var(--sl-hsl-background));color:hsl(var(--sl-hsl-foreground));padding:0 1rem;gap:1rem}.sl-topbar--pinned{position:fixed;top:0;left:0;right:0;padding-top:env(safe-area-inset-top,0);padding-left:max(1rem,env(safe-area-inset-left,0));padding-right:max(1rem,env(safe-area-inset-right,0));border-bottom:1px solid hsl(var(--sl-hsl-border));background:hsl(var(--sl-hsl-background) / 0.85);-webkit-backdrop-filter:blur(8px);backdrop-filter:blur(8px)}.sl-topbar--sticky{position:sticky;top:0;z-index:var(--sl-z-sticky,1020);padding-top:env(safe-area-inset-top,0);padding-left:max(1rem,env(safe-area-inset-left,0));padding-right:max(1rem,env(safe-area-inset-right,0));border-bottom:1px solid hsl(var(--sl-hsl-border));background:hsl(var(--sl-hsl-background) / 0.85);-webkit-backdrop-filter:blur(8px);backdrop-filter:blur(8px)}.sl-topbar--floating{position:relative;margin:var(--sl-topbar-margin,1rem 1rem 0);border:1px solid hsl(var(--sl-hsl-border));border-radius:var(--sl-topbar-radius,var(--sl-radius-lg))}.sl-topbar--flat{position:relative;border-bottom:1px solid hsl(var(--sl-hsl-border) / 0.5)}.sl-topbar--no-border{border:none !important}.sl-topbar__start{display:flex;align-items:center;flex:1;gap:0.5rem}.sl-topbar__center{display:flex;align-items:center;justify-content:center;flex:2}.sl-topbar__end{display:flex;align-items:center;justify-content:flex-end;flex:1;gap:0.5rem}.sl-topbar__start slot[name="start"]::slotted(*),.sl-topbar__center slot[name="center"]::slotted(*),.sl-topbar__end slot[name="end"]::slotted(*){display:flex;align-items:center}@media (max-width:768px){.sl-topbar__center{display:none}.sl-topbar{padding:0 0.75rem}.sl-topbar--pinned,.sl-topbar--sticky{-webkit-backdrop-filter:blur(4px);backdrop-filter:blur(4px)}}';
class a extends HTMLElement {
  static get observedAttributes() {
    return ["variant", "height", "no-border"];
  }
  constructor() {
    super(), this._shadow = this.attachShadow({ mode: "open" });
  }
  connectedCallback() {
    this._render();
  }
  disconnectedCallback() {
  }
  attributeChangedCallback(t, e, r) {
    e !== r && this._render();
  }
  get variant() {
    return this.getAttribute("variant") || "pinned";
  }
  set variant(t) {
    this.setAttribute("variant", t);
  }
  get height() {
    return this.getAttribute("height") || "3.5rem";
  }
  set height(t) {
    this.setAttribute("height", t);
  }
  get noBorder() {
    return this.hasAttribute("no-border");
  }
  set noBorder(t) {
    t ? this.setAttribute("no-border", "") : this.removeAttribute("no-border");
  }
  _getClasses() {
    const t = ["sl-topbar"];
    return t.push(`sl-topbar--${this.variant}`), this.noBorder && t.push("sl-topbar--no-border"), t.join(" ");
  }
  _render() {
    const t = `
      --sl-topbar-height: ${this.height};
    `;
    this._shadow.innerHTML = `
      <style>
        ${s}
        :host {
          ${t}
        }
      </style>
      <div class="${this._getClasses()}">
        <div class="sl-topbar__start">
          <slot name="start"></slot>
        </div>
        <div class="sl-topbar__center">
          <slot name="center"></slot>
        </div>
        <div class="sl-topbar__end">
          <slot name="end"></slot>
        </div>
      </div>
    `;
  }
}
typeof customElements < "u" && !customElements.get("sl-topbar") && customElements.define("sl-topbar", a);
export {
  a as SlTopbarElement
};
//# sourceMappingURL=sl-topbar.js.map
